__webpack_require__.p = "/energy/paper/Sustainable_Bioeconomy/";